/** Known Pages custom domains use the browser-owned API/WebDAV contract. */
export function isCloudflareRuntimeHost(hostname: string): boolean {
  return /^(?:(?:www\.)?(?:shytest|shymusic)|apple\.shymusic)\.cc\.cd$/i.test(hostname)
    || hostname.toLowerCase().endsWith('.pages.dev');
}
